import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import Measurement from "@arcgis/core/widgets/Measurement";
import * as watchUtils from "@arcgis/core/core/watchUtils";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";

const MeasurementWidget = observer(({ view, CommunicationStore, deactivate }) => {
  const container = useRef(null);
  const measure = useRef(null);
  const [activeTool, setActiveTool] = useState(null);

  useEffect(() => {
    measure.current = new Measurement({
      view: RootStore.mapStore.mapView,
      activeTool: activeTool
    });

    watchUtils.whenDefined(measure.current, "activeWidget", (widget) => {
      if (widget) {
        widget.unit = "metric";
        widget.unitOptions = widget.unitOptions.filter((option) =>
          [
            "metric",
            "meters",
            "kilometers",
            "square-meters",
            "square-kilometers"
          ].includes(option)
        );
      }
    });

    measure.current.container =
      document.getElementsByClassName("widget-container")[0];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   measure.current.activeTool = activeTool;
  // }, [activeTool]);

  useEffect(() => {
    if (activeTool) {
      CommunicationStore.addMessage({
        to: "activeMapWidget",
        message: "measure",
      });
    }
  }, [activeTool]);
  const activeMapWidget = CommunicationStore.getMessagesToID({
    to: "activeMapWidget",
  })?.message;


  const clearMeasurements = () => {
    measure.current.clear();
    setActiveTool(null);
  };

  useEffect(() => {
    if (activeMapWidget && activeMapWidget != "measure") {
      clearMeasurements();
      deactivate();
    }
  }, [activeMapWidget])

  const selectTool = (tool) => {
    setActiveTool(tool);
    measure.current.activeTool = tool;
  };

  const isActiveClass = (tool) => {
    return activeTool === tool ? "active" : "";
  };

  return (
    // <div>
    <div ref={container} id="measure-widget-container">
      <div style={{ display: "flex" }}>
        <button
          id="distance"
          className={`esri-widget--button esri-interactive esri-icon-measure-line ${isActiveClass(
            "distance"
          )}`}
          title="Distanzen"
          onClick={() => selectTool("distance")}
        ></button>
        <button
          id="area"
          className={`esri-widget--button esri-interactive esri-icon-measure-area ${isActiveClass(
            "area"
          )}`}
          title="Fläche"
          onClick={() => selectTool("area")}
        ></button>
        <button
          id="clear"
          className="esri-widget--button esri-interactive esri-icon-trash"
          title="Zurücksetzen"
          onClick={clearMeasurements}
        ></button>
      </div>
      <div className="widget-container"></div>
    </div>
    // </div>
  );
});

export default MeasurementWidget;
